var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComb3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12627 2.63136C6.96808 1.78955 8.33293 1.78955 9.17475 2.63136L21.3686 14.8253C22.2105 15.6671 22.2105 17.0319 21.3686 17.8737L17.558 21.6843C17.1371 22.1052 16.4547 22.1052 16.0338 21.6843L15.2717 20.9222C14.8508 20.5013 14.8508 19.8189 15.2717 19.398L18.3202 16.3495L16.7959 14.8253L13.7475 17.8737C13.3266 18.2946 12.6441 18.2946 12.2232 17.8737C11.8023 17.4528 11.8023 16.7704 12.2232 16.3495L15.2717 13.301L13.7475 11.7768L10.699 14.8253C10.2781 15.2462 9.59565 15.2462 9.17475 14.8253C8.75384 14.4043 8.75384 13.7219 9.17475 13.301L12.2232 10.2525L10.699 8.72831L7.65051 11.7768C7.2296 12.1977 6.54718 12.1977 6.12627 11.7768C5.70537 11.3559 5.70537 10.6735 6.12627 10.2525L9.17475 7.20407L7.65051 5.67983L4.60204 8.72831C4.18113 9.14921 3.4987 9.14921 3.0778 8.72831L2.31568 7.96619C1.89477 7.54528 1.89477 6.86286 2.31568 6.44195L6.12627 2.63136Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComb3);
export default __webpack_public_path__ + "static/media/comb-3.640a4a92800667cbe5d995253d6ccca0.svg";
export { ForwardRef as ReactComponent };